import { z } from 'zod';
import { VALIDATION_LIMITS } from '../utils/constants';
import { UserRole } from '../types/user';
export const loginSchema = z.object({
    email: z.string().email('Invalid email address'),
    password: z.string().min(1, 'Password is required'),
});
export const registerSchema = z
    .object({
    email: z.string().email('Invalid email address'),
    username: z
        .string()
        .min(VALIDATION_LIMITS.USERNAME.MIN_LENGTH, `Username must be at least ${VALIDATION_LIMITS.USERNAME.MIN_LENGTH} characters`)
        .max(VALIDATION_LIMITS.USERNAME.MAX_LENGTH, `Username must be less than ${VALIDATION_LIMITS.USERNAME.MAX_LENGTH} characters`)
        .regex(/^[a-zA-Z0-9_]+$/, 'Username can only contain letters, numbers, and underscores'),
    password: z
        .string()
        .min(VALIDATION_LIMITS.PASSWORD.MIN_LENGTH, `Password must be at least ${VALIDATION_LIMITS.PASSWORD.MIN_LENGTH} characters`)
        .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, 'Password must contain uppercase, lowercase, and number'),
    confirm_password: z
        .string()
        .min(VALIDATION_LIMITS.PASSWORD.MIN_LENGTH, `Password must be at least ${VALIDATION_LIMITS.PASSWORD.MIN_LENGTH} characters`)
        .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, 'Password must contain uppercase, lowercase, and number'),
    first_name: z.string().min(1, 'First name is required'),
    last_name: z.string().min(1, 'Last name is required'),
    role: z.nativeEnum(UserRole, {
        errorMap: () => ({ message: 'Please select a valid role' }),
    }),
    terms_accepted: z
        .boolean()
        .refine(val => val === true, 'You must accept the terms'),
})
    .refine(data => data.password === data.confirm_password, {
    message: "Passwords don't match",
    path: ['confirm_password'],
});
export const passwordResetRequestSchema = z.object({
    email: z.string().email('Invalid email address'),
});
export const passwordResetSchema = z.object({
    token: z.string().min(1, 'Reset token is required'),
    new_password: z
        .string()
        .min(VALIDATION_LIMITS.PASSWORD.MIN_LENGTH, `Password must be at least ${VALIDATION_LIMITS.PASSWORD.MIN_LENGTH} characters`)
        .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, 'Password must contain uppercase, lowercase, and number'),
});
export const changePasswordSchema = z
    .object({
    current_password: z.string().min(1, 'Current password is required'),
    new_password: z
        .string()
        .min(VALIDATION_LIMITS.PASSWORD.MIN_LENGTH, `Password must be at least ${VALIDATION_LIMITS.PASSWORD.MIN_LENGTH} characters`)
        .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, 'Password must contain uppercase, lowercase, and number'),
    confirm_password: z.string(),
})
    .refine(data => data.new_password === data.confirm_password, {
    message: "Passwords don't match",
    path: ['confirm_password'],
});
export const emailVerificationSchema = z.object({
    token: z.string().min(1, 'Verification token is required'),
});
